import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api";
import { BackIcon } from "../components/icons";

/**
 * Two-card screen the user lands on after tapping "New book". One card
 * starts the existing polish flow (creates an empty draft and jumps to
 * Compose); the other routes to /new/story which collects the parent's
 * brief + page count in a single form.
 */
export default function NewBookChoice() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const startPolish = async () => {
    if (busy) return;
    setBusy(true);
    setErr(null);
    try {
      const book = await api.createBook({ title: "" });
      navigate(`/app/books/${book.id}`, { replace: true });
    } catch (e) {
      setErr(String(e));
      setBusy(false);
    }
  };

  return (
    <div className="tp-app tp-wide">
      <div className="tp-topbar">
        <Link to="/app" className="tp-btn tp-btn-ghost" aria-label={t("common.back")} style={{ textDecoration: "none" }}>
          <BackIcon /> {t("common.back")}
        </Link>
      </div>
      <div className="tp-screen" style={{ paddingTop: 24 }}>
        <div className="tp-display" style={{ marginBottom: 8, fontSize: 36 }}>{t("newBookChoice.heading")}</div>
        <div className="tp-body" style={{ color: "var(--tp-ink-soft)", marginBottom: 24, fontSize: 16 }}>
          {t("newBookChoice.subheading")}
        </div>

        {err && <div className="tp-error" style={{ marginBottom: 16 }}>{err}</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <button
            type="button"
            className="tp-card"
            onClick={startPolish}
            disabled={busy}
            style={{ textAlign: "left", cursor: "pointer", font: "inherit", color: "inherit", border: undefined, padding: 20 }}
          >
            <div className="tp-h2" style={{ marginBottom: 6 }}>{t("newBookChoice.photosTitle")}</div>
            <div className="tp-body" style={{ color: "var(--tp-ink-soft)", lineHeight: 1.45 }}>
              {t("newBookChoice.photosBody")}
            </div>
          </button>

          <Link
            to="/app/new/story"
            className="tp-card"
            style={{ textDecoration: "none", color: "inherit", padding: 20 }}
          >
            <div className="tp-h2" style={{ marginBottom: 6 }}>{t("newBookChoice.ideaTitle")}</div>
            <div className="tp-body" style={{ color: "var(--tp-ink-soft)", lineHeight: 1.45 }}>
              {t("newBookChoice.ideaBody")}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
